import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
  /** App constants go here */

  // Error Codes
  NOT_FOUND_ERROR = '500';
}
